import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const CALENDLY_URL =
  "https://calendly.com/divinelovewellnessenterprises/consultationmeeting";

/**
 * Inline Calendly booking widget. Uses Calendly's official embed URL so
 * warm visitors can pick a time without leaving the site.
 */
export const CalendlyInlineBooking = ({ background = "bg-white" }) => (
  <section
    className={`py-20 md:py-24 px-6 md:px-12 ${background}`}
    data-testid="calendly-inline-section"
  >
    <div className="max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-8"
      >
        <span className="inline-flex items-center gap-2 text-primary font-medium text-sm uppercase tracking-[0.18em]">
          <Sparkles className="h-4 w-4" />
          Book in 2 Minutes
        </span>
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mt-4 leading-tight">
          Pick a time for your free 40-minute consultation
        </h2>
        <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          No pressure, no forms — just choose a slot below that works for you
          and I&rsquo;ll see you there.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="rounded-3xl overflow-hidden shadow-soft border border-border/30 bg-white"
      >
        <iframe
          title="Book your free 40-minute consultation with Laura A. Jeanis"
          src={`${CALENDLY_URL}?embed_domain=divinelovewellness.net&embed_type=Inline&hide_gdpr_banner=1`}
          className="w-full border-0"
          style={{ minHeight: "720px" }}
          loading="lazy"
          data-testid="calendly-iframe"
        />
      </motion.div>
    </div>
  </section>
);

export default CalendlyInlineBooking;
